import {
  DeactivateAllDomainsProductMutation,
  DeactivateAllDomainsProductMutationVariables,
} from 'gql/graphql'

import { useMutation } from 'providers/tanstack-query/useMutation'
import { useDomainsProductSnackbar } from '../useDomainsProductSnackbar'
import { DEACTIVATE_ALL_DOMAINS_PRODUCT } from './mutation'

import type { UseDeactivateAllDomainsProduct } from './types'

export const useDeactivateAllDomainsProduct = (): UseDeactivateAllDomainsProduct => {
  const { snackbar } = useDomainsProductSnackbar()

  const { isPending: loading, mutateAsync } = useMutation<
    DeactivateAllDomainsProductMutationVariables,
    DeactivateAllDomainsProductMutation
  >({
    mutation: DEACTIVATE_ALL_DOMAINS_PRODUCT,
    onCompleted: async (
      data: DeactivateAllDomainsProductMutation,
      variables: DeactivateAllDomainsProductMutationVariables,
    ) => {
      const { deactivateAllDomainsProduct } = data
      const product = variables.input.productType

      if (deactivateAllDomainsProduct?.errors) {
        const { errors } = deactivateAllDomainsProduct

        if (errors && errors.length > 0) {
          snackbar({ enabled: false, product, variant: 'error' })
        }
      } else {
        snackbar({ enabled: false, product, variant: 'success' })
      }
    },
    queriesToInvalidate: ['getDomainsForTable'],
  })

  const deactivateAllDomainsProduct: UseDeactivateAllDomainsProduct['deactivateAllDomainsProduct'] =
    product => {
      void mutateAsync({
        input: {
          productType: product,
        },
      })
    }

  return { deactivateAllDomainsProduct, loading }
}
